import React, { useEffect, useState } from 'react'
import "./slipStyles.css";
import { useSelector } from 'react-redux'
import { selectCurrentAddressLabelData } from '../app/features/memberReportSlice'
import { Button } from '@mui/material';
import { useLazyGetAllMemberShipDetailsQuery } from '../app/services/memberShipServices';
import { useSearchParams } from 'react-router-dom';


const AddressLabelPreviewInstitution = () => {
    const data = useSelector(selectCurrentAddressLabelData);
    const memberData = data.filter(
        (item, index, self) =>
            index === self.findIndex((t) => t._id === item._id)
    );
    const type = useSearchParams()[0].get("type");
    const [membershipData, setMembershipData] = useState(null);
    const [getAllmembershipData] = useLazyGetAllMemberShipDetailsQuery();
    useEffect(() => {
        getAllmembershipData().then((res) => {
            const data = res?.data?.data.find(plan => plan?.planName === type)
            setMembershipData(data)
        })
    }, [getAllmembershipData, type])

    return (
        <>
            <div className="pt-5 d-print-none">
                <div className="chapter-heading ">
                    <h2 className="text-center title-font text-light py-3 mt-1">
                        Address Labels for Print
                    </h2>
                </div>
            </div>
            <div className="p-md-5 p-3 overallPadding">
                <div className="text-end mb-3 no-print">
                    <Button
                        onClick={() => window.history.back()}
                        variant="contained"
                        className="menus-color"
                    >
                        Back
                    </Button>
                </div>
                <div className="print-container">
                    {memberData.map((user, index) => {
                        const plan = user.plans.findLast(p => p.isPaid === 1) || {};
                        return (
                            <>
                                <div className="slip-box" key={user._id}>
                                    <div className="plan-header">
                                        {(type === 3 || type === '3') ? 'Institutional Membership' : 'Corporate Supporter MemberShip'} <br />{membershipData && membershipData?.planType.find(typ => typ?._id === plan?.planTypeId)?.planTypeName} Plan &nbsp;
                                        <strong> ID:  {user.userId}</strong>
                                    </div>
                                    <div className="to-address">
                                        <div className='d-flex justify-content-between'>
                                            <strong>To</strong> <div className="expires">Expires on {new Date(plan.planEndDate).toLocaleDateString('en-GB', {
                                                year: 'numeric', month: '2-digit', day: '2-digit', formatMatcher: 'basic'
                                            })}</div>
                                        </div>
                                        {user.addressedTo} <br /> <strong className='text-capitalize'>{(type === 3 || type === '3') ? user.institution : user.organisationName}</strong><br />
                                        <span className='address-text'>{user.address.toLowerCase()}, {user.city.toLowerCase()}, {user.district ? `${user.district.toLowerCase()}, ` : ' '}{user.state.toLowerCase()}</span><br />
                                        <strong>PIN - {user.pinCode}</strong> &nbsp;
                                        <div className='d-flex justify-content-between'>
                                            <span><strong>Mobile: </strong>{user.mobileNumber}</span><span className='text-secondary'>{index + 1}</span>
                                        </div>
                                    </div>
                                    <div className="slip-footer"></div>
                                </div>
                            </>
                        );
                    })}
                </div>
                <div className="text-center my-3 w-100 d-flex gap-3 justify-content-between">
                    <Button
                        onClick={() => window.history.back()}
                        variant="contained"
                        className="menus-color d-print-none"
                    >
                        Back to Generate label form
                    </Button>
                    <Button
                        onClick={() => window.print()}
                        variant="contained"
                        className="rounded-0 d-print-none"
                        color="primary"
                    >
                        Print
                    </Button>
                </div>
            </div>
        </>
    );
};

export default AddressLabelPreviewInstitution;
